const baseUrl = import.meta.env.VITE_APP_API_URL || 'http://localhost:3000';
const baseUrlW = import.meta.env.VITE_APP_WS_URL || 'ws://localhost:3000';

// For local development
// const baseUrl = "http://localhost:4050/test";
// const baseUrlW = "ws://localhost:4050/ws";

// For production
// const baseUrl = "https://alsaqr.io:8443/test";
// const baseUrlW = "wss://alsaqr.io:8443/ws";
 
export default baseUrl;
export { baseUrlW };